import { render, staticRenderFns } from "./UcExchangeRateSourceDisplay.yaml?vue&type=template&id=9c0ed79e&component"
import script from "./UcExchangeRateSourceDisplay.yaml?vue&type=script&lang=ts&component"
export * from "./UcExchangeRateSourceDisplay.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports